import FormFieldInput from 'components/revelo-ui/forms/form-field-input';
import Button from 'components/revelo-ui/content/button';
import { FormProvider, useForm } from 'react-hook-form';
import React from 'react';
import { Account, Address } from '@Types/account';
import { useAccount } from '@Provider/frontastic';

export interface PersonalDataFormProps {
  defaultShippingAddress: Address;
  defaultBillingAddress?: Address;
  closeEditMode?: (data?: any) => void;
}

const PersonalDataForm: React.FC<PersonalDataFormProps> = ({
  defaultBillingAddress,
  defaultShippingAddress,
  closeEditMode,
}) => {
  const { account, updateAccount, updateAddresses } = useAccount();

  const formMethods = useForm({
    mode: 'onChange',
  });

  const { handleSubmit } = formMethods;

  const onSubmit = async (formData) => {
    const addresses = [];
    if (defaultShippingAddress) {
      addresses.push({ ...defaultShippingAddress, phone: formData.phone });
    }

    if (defaultBillingAddress) {
      addresses.push({ ...defaultBillingAddress, phone: formData.phone });
    }

    try {
      await updateAccount({ firstName: formData.firstName, lastName: formData.lastName });
      if (addresses) {
        await updateAddresses(addresses);
      }

      closeEditMode();
    } catch (error) {
      console.error('Error while updating account:', error);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <div>
          <FormFieldInput
            name="firstName"
            inputType="text"
            inputAutoComplete="given-name"
            value={account.firstName || ''}
            containerClassNames=""
            label="Vorname"
            placeholder="Vorname"
          />
        </div>
        <div>
          <FormFieldInput
            name="lastName"
            inputType="text"
            inputAutoComplete="family-name"
            value={account.lastName || ''}
            containerClassNames=""
            label="Nachname"
            placeholder="Nachname"
          />
        </div>
        {defaultShippingAddress && (
          <div>
            <FormFieldInput
              name="phone"
              inputType="phone"
              inputAutoComplete="phone"
              value={defaultShippingAddress?.phone || ''}
              containerClassNames=""
              label="Telefonnummer"
              placeholder="Telefonnummer"
            />
          </div>
        )}
        <div>
          <Button style="secondary" type="submit">
            Änderungen speichern
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default PersonalDataForm;
